interface RemovedUrlQueriesProps {
  queryKeys: string[];
}

export const removedUrlQueries = ({ queryKeys }: RemovedUrlQueriesProps) => {
  // Remove preview-related query params from the URL using native API
  // and also sync React Router by dispatching a popstate event
  const url = new URL(window.location.href);
  queryKeys.forEach((key) => url.searchParams.delete(key));
  window.history.replaceState({}, '', url.toString());
  // Dispatch popstate so React Router picks up the URL change
  window.dispatchEvent(new PopStateEvent('popstate'));
};

export const TAB_QUERY_KEY = ['tab'];
export const CHILD_TAB_QUERY_KEY = ['childTab'];
export const CHILD_SUB_TAB_QUERY_KEY = ['childSubTab'];

export const PDF_REDIRECT_QUERY_KEYS = [
  'checkPointId',
  'resultObjectId',
  'toDamageList',
  'toAllDamagesList',
  'checkPointImageUrl',
];
